import { CreateInstance } from "./config"
const DepartmentsAPI = CreateInstance("departments")
export default DepartmentsAPI
